import { t } from "@travily/i18n";
import { StandardButton } from "@ui/components/StandardButton";
import { Link } from "@ui/primitives/Link";

export interface ResentViewProps {
  /** Masked recipient address shown in the confirmation copy. */
  maskedEmail: string;
  /** Destination for the "back home" button. */
  homeHref: string;
}

// Shown after a buyer clicks an expired download link: a fresh link has been
// emailed, so point them at their inbox.
export const ResentView = ({ maskedEmail, homeHref }: ResentViewProps) => (
  <div className="mx-auto w-full max-w-xl py-16">
    <h1 className="font-bold text-2xl text-neutral-900">{t("web.purchases.downloads.resent.heading")}</h1>
    <p className="mt-3 text-base text-neutral-700">
      {t("web.purchases.downloads.resent.description", { email: maskedEmail })}
    </p>
    <p className="mt-2 text-neutral-500 text-sm">{t("web.purchases.downloads.resent.spam_note")}</p>

    <div className="mt-8">
      <Link href={homeHref}>
        <StandardButton color="pink" size="44">
          {t("web.purchases.downloads.resent.back_home")}
        </StandardButton>
      </Link>
    </div>
  </div>
);
